<template>
    <dialog-form
        ref="form"
        :value="value"
        @input="$emit('input', $event)"
        :title="$localize('CreateOffer.title')"
        @commit="save"
        :allow-continue="false"
        @reset="createOffer = { displayGrandTotal: true }"
        :loading="loading"
        :action-text="
            sendOffer
                ? $localize('CreateOffer.button.createAndSendOffer')
                : $localize('CreateOffer.button.createOffer')
        "
    >
        <select-address
            v-if="project.relationId"
            :relation-id="project.relationId"
            v-model="createOffer.addressId"
            :select-first="true"
            :required="false"
        />

        <date-select
            v-model="createOffer.offerDate"
            :label="$localize('Offer.created')"
        />
        <date-select
            v-model="createOffer.expires"
            :label="$localize('Offer.expires')"
        />

        <v-switch
            v-model="createOffer.displayGrandTotal"
            :label="$localize('Offer.displayGrandTotal')"
        />
        <v-checkbox v-model="sendOffer" label="Email versturen" />
        <send-email-form
            v-if="sendOffer"
            v-model="emailData.email"
            :relation-id="emailData.relationId"
            :contact-id="emailData.contactId"
            @nav="nav"
        />
        <v-checkbox v-model="changeStatus" label="Status veranderen" />
        <v-row>
            <v-col cols="4">
                <select-phases
                    v-if="changeStatus"
                    v-model="changePhase"
                    :multiple="false"
                    allow-archive
                />
            </v-col>
            <v-col cols="8">
                <select-project-statuses
                    v-if="changeStatus"
                    v-model="changeStatusId"
                    :allow-all="false"
                    :allow-multiple="false"
                    :phase="changePhase"
                />
            </v-col>
        </v-row>
        <v-textarea
            v-if="changeStatus"
            v-model="note"
            :label="$localize('ChangeStatusStep.label.note')"
            :rules="[validation.maxLength(2000)]"
        />
        <template v-slot:actions-right>
            <v-btn class="mt-3" @click="downloadExample">
                Voorbeeld
                <v-icon class="red--text">mdi-adobe-acrobat</v-icon>
            </v-btn>
        </template>
    </dialog-form>
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'
import DateSelect from '@/shared/components/DateSelect'

import sendCommand from '@/services/sendCommand'
import { isGuid, maxLength } from '@/services/validation'
import SelectAddress from '@/main/components/forms/SelectAddress'
import SendEmailForm from '../components/steps/SendEmailForm'
import SelectProjectStatuses from '@/main/components/forms/SelectProjectStatuses'
import SelectPhases from '@/main/components/forms/SelectPhases'
import {
    getProjectById,
    getExampleOffer,
    prepareOfferEmail,
} from '@/services/api'
import { format, addDays } from 'date-fns'
import Vue from 'vue'
export default {
    components: {
        DialogForm,
        DateSelect,
        SelectAddress,
        SendEmailForm,
        SelectProjectStatuses,
        SelectPhases,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        projectId: {
            validator: isGuid,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            project: {},
            createOffer: {},
            emailData: {},
            sendOffer: false,
            validation: { maxLength },
            changePhase: 'offer',
            changeStatusId: this.$settings.initialCreateOfferStatus,
            changeStatus: !!this.$settings.initialCreateOfferStatus,
            note: '',
        }
    },
    async created() {
        this.loading = true
        const { result, ok } = await getProjectById.call({
            args: { projectId: this.projectId },
        })
        if (ok) {
            this.project = result
            this.createOffer = {
                offerDate: format(new Date(), 'yyyy-MM-dd'),
                expires: format(
                    addDays(new Date(), this.$settings.offerValidityDays || 30),
                    'yyyy-MM-dd'
                ),
                displayGrandTotal: true,
                addressId: this.project.offerAddressId,
            }
            await this.loadEmailData()
        }
        this.loading = false
    },
    methods: {
        async loadEmailData() {
            const { result, ok } = await prepareOfferEmail.call({
                args: { projectId: this.projectId },
            })
            if (ok) {
                this.emailData = result
            }
        },
        async save(callback) {
            var message = {
                relationId: this.project.relationId,
                projectId: this.projectId,
                offerDate: this.createOffer.offerDate,
                expires: this.createOffer.expires,
                displayGrandTotal: this.createOffer.displayGrandTotal,
            }

            if (this.sendOffer) {
                message.email = this.emailData.email
            }
            if (this.changeStatus) {
                message.changePhase = this.changePhase
                message.changeStatusId = this.changeStatusId
                message.note = this.note
            }
            const result = await sendCommand('CreateOffer', message)

            if (result.success) {
                this.$emit('saved')
            }
            callback({ success: result.success })
        },
        downloadExample() {
            if (!this.$refs.form.$refs.form.validate()) {
                return
            }
            var downloadUrl = getExampleOffer.create({
                projectId: this.projectId,
            }).url
            downloadUrl += `?showGrandTotal=${this.createOffer.displayGrandTotal}&offerDate=${this.createOffer.offerDate}&expires=${this.createOffer.expires}`
            if (this.createOffer.addressId) {
                downloadUrl += `&addressId=${this.createOffer.addressId}`
            }
            window.location = downloadUrl
        },
        nav(to) {
            this.$emit('input', false)
            Vue.nextTick(() => {
                this.$router.push(to)
            })
        },
    },
}
</script>
